import { render, staticRenderFns } from "./GiveTracker.vue?vue&type=template&id=b107e71e&scoped=true&"
import script from "./GiveTracker.vue?vue&type=script&lang=js&"
export * from "./GiveTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b107e71e",
  null
  
)

export default component.exports